export const MOCK_PROVIDERS = [
  {
    age_groups_seen: ['Pediatrics', 'Teeangers', 'Adults', 'Geriatrics'],
    avatar: 'm1',
    certifications: undefined,
    department: 'Primary Care',
    general: 'It is important to me that my patients feel heard. I enjoy helping them reach their health goals and being their partner in the decision-making process. In my spare time, I enjoy learning new recipes, exercising, poetry, and spending time visiting my family.',
    id: '1',
    providerIdType: 'External',
    inNetwork: false,
    locations: {
      items: [[
        {
          address: '221 E. Fourth St., Tampa, FL 33664',
          id: 1,
          name: 'Enlyt Health - Downtown',
          phone: '5139248414'
        },
        {
          address: '221 E. Fourth St., Tampa, FL 33664',
          id: 2,
          name: 'Enlyt Health - Downtown',
          phone: '5139248414'
        }
      ]]
    },
    name: 'Seth Draper',
    phone: '8474162092',
    rating: 4.2,
    specialization: 'Family Medicine',
    title: 'MD'
  },
  {
    age_groups_seen: ['Pediatrics', 'Teeangers', 'Adults', 'Geriatrics'],
    avatar: 'w1',
    certifications: [],
    department: 'Primary Care',
    general: 'It is important to me that my patients feel heard. I enjoy helping them reach their health goals and being their partner in the decision-making process. In my spare time, I enjoy learning new recipes, exercising, poetry, and spending time visiting my family.',
    id: '2',
    providerIdType: 'External',
    inNetwork: false,
    locations: {
      items: [[
        {
          address: '221 E. Fourth St., Tampa, FL 33664',
          id: 1,
          name: 'Enlyt Health - Downtown',
          phone: '5139248414'
        }
      ]]
    },
    name: 'Laura Valencia',
    phone: '8474162032',
    rating: 5,
    specialization: 'Cardiology',
    title: 'MD'
  },
  {
    age_groups_seen: ['Pediatrics'],
    avatar: 'm2',
    certifications: undefined,
    department: 'Primary Care',
    general: 'It is important to me that my patients feel heard. I enjoy helping them reach their health goals and being their partner in the decision-making process. In my spare time, I enjoy learning new recipes, exercising, poetry, and spending time visiting my family.',
    id: '3',
    providerIdType: 'External',
    inNetwork: true,
    locations: {
      items: [[
        {
          address: '221 E. Fourth St., Tampa, FL 33664',
          id: 1,
          name: 'Enlyt Health - Downtown',
          phone: '5139248414'
        }
      ]]
    },
    name: 'Jim Singer',
    phone: '8474162090',
    rating: 4.8,
    specialization: 'Diagnostic Imaging',
    title: 'MD'
  },
  {
    age_groups_seen: ['Adults', 'Geriatrics'],
    avatar: 'w4',
    certifications: [],
    department: 'Primary Care',
    general: 'It is important to me that my patients feel heard. I enjoy helping them reach their health goals and being their partner in the decision-making process. In my spare time, I enjoy learning new recipes, exercising, poetry, and spending time visiting my family.',
    id: '4',
    providerIdType: 'External',
    inNetwork: false,
    locations: {
      items: [[
        {
          address: '221 E. Fourth St., Tampa, FL 33664',
          id: 1,
          name: 'Enlyt Health - Downtown',
          phone: '5139248414'
        }
      ]]
    },
    name: 'Jane Kovach',
    phone: '8474162091',
    rating: 4.4,
    specialization: 'Emergency Room',
    title: 'MD'
  },
  {
    age_groups_seen: ['Pediatrics', 'Teeangers', 'Adults'],
    avatar: 'm3',
    certifications: [],
    department: 'Primary Care',
    general: 'It is important to me that my patients feel heard. I enjoy helping them reach their health goals and being their partner in the decision-making process. In my spare time, I enjoy learning new recipes, exercising, poetry, and spending time visiting my family.',
    id: '5',
    providerIdType: 'External',
    inNetwork: true,
    locations: {
      items: [[
        {
          address: '221 E. Fourth St., Tampa, FL 33664',
          id: 1,
          name: 'Enlyt Health - Downtown',
          phone: '5139248414'
        }
      ]]
    },
    name: 'Paul Kramer',
    phone: '8474162035',
    rating: 4.6,
    specialization: 'Endocrinology',
    title: 'MD'
  }
]
